module.exports = __webpack_public_path__ + "static/media/redDragonOnline.b8fc4fbf.png";